import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import VectorSource from 'ol/source/Vector'
import {
  Tile as TileLayer,
  Vector as VectorLayer
} from 'ol/layer'
import {
  createStringXY
} from 'ol/coordinate'
import Projection from 'ol/proj/Projection';
import XYZ from 'ol/source/XYZ'
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature'
import {
  Circle,
  MultiPoint,
  Point
} from 'ol/geom'
import {
  Circle as CircleStyle,
  Fill,
  Text,
  Stroke,
  Style,
  Icon,
  RegularShape
} from 'ol/style'
import {
  transform,
  get,
  fromLonLat,
  toLonLat
} from 'ol/proj'
import {
  ScaleLine,
  defaults as defaultControls
} from 'ol/control'
import Overlay from 'ol/Overlay'
import {
  LineString,
  Polygon,
} from 'ol/geom';
import {
  Draw,
} from 'ol/interaction.js'

let _this = null;
let iMap = null;
let radius = 1
let scale = 0.5;
let vectorSource, vectorLayer, element, popup, provinceSorce, provinLayer
//传递vue实例
function sendThis(vm) {
  _this = vm
}
//初始化地图
function Load_Map(param) {
  iMap = null;
  let map = document.getElementById('map');
  map.innerHTML = '';
  let layer = new TileLayer({
    source: new OSM({
      // url: 'https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
      url: param.photography ? "https://webst02.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}" : 'https://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}',
      crossOrigin: 'anonymous',
    }),
  });
  vectorSource = new VectorSource()
  vectorLayer = new VectorLayer({
    source: vectorSource,
  })
  provinceSorce = new VectorSource()
  provinLayer = new VectorLayer({
    source: provinceSorce
  })
  let mappParma = {
    zoom: 4.666666666666667,
    mapCenter: [109.5, 34.52],
  }
  if (param.mappParma) {
    mappParma = param.mappParma
  }
  iMap = new Map({
    layers: [layer, provinLayer, vectorLayer],
    target: 'map',
    view: new View({
      projection: 'EPSG:3857',
      center: mappParma.mapCenter[0] > 200 ? mappParma.mapCenter : fromLonLat(mappParma.mapCenter),
      maxZoom: 22,
      minZoom: 3,
      zoom: mappParma.zoom,
    }),
  })
  if (param.popup) {
    element = document.getElementById('popup')
    element.innerHTML = '南京\r52个'
    popup = new Overlay({
      element: element,
      offset: [0, -12],
      positioning: 'bottom-center',
    })
    iMap.addOverlay(popup)
    // iMap.on('postcompose', animation)
    iMap.on('pointermove', MapPointerMove)
    iMap.on('moveend', mapMoved)
    iMap.on('singleclick', MapPointerClickOpen)
  }
}

//地图增加圆点层
function addCricle(dataJson) {
  vectorSource.clear();
  dataJson.forEach(el => {
    let coordinate = [Number(el.longitudeAndLatitude.split(',')[0]), Number(el.longitudeAndLatitude.split(',')[1])];
    let feature = new Feature({
      geometry: new Point([coordinate[0] + (Math.floor(Math.random() * (1000 - 1) + 1) - 500) * 0.1, coordinate[1] + (Math.floor(Math.random() * (1000 - 1) + 1) - 500) * 0.1])
    })
    feature.set('radius', 10 / el.grade)
    feature.set('value', el.cou)
    feature.set('name', el.companyName)
    feature.set('_type', 'vector')
    feature.set('grade', el.grade)
    feature.set('compayId', el.id)
    var custom;
    if(el.grade==1){
      custom='../../../../static/img/customer1.svg'
    }else if(el.grade==5){
      custom='../../../../static/img/customer3.svg'
    }else{
      custom='../../../../static/img/customer2.svg'
    }
    feature.setStyle(
      [
        new Style({
          image: new Icon({
            scale: 0.5,
            src: custom
          }),
        })
        // new Style({
        //   image: new CircleStyle({
        //     fill: new Fill({
        //       color: 'rgba(54,110,255,0.5)',
        //     }),
        //     radius: feature.get('grade') == 1 ? feature.get('radius') : feature.get('radius') * 3,
        //   }),
        // }),
        // new Style({
        //   image: new CircleStyle({
        //     fill: new Fill({
        //       color: feature.get('grade')==5?'rgba(0,48,255,0.7)':'#366EFF',
        //     }),
        //     stroke: new Stroke({
        //       color: '#FFF',
        //       width: feature.get('grade')==5?1:2,
        //     }),
        //     radius: feature.get('grade') == 1 ? feature.get('radius') : feature.get('radius') * 1.5,
        //   }),
        // })
      ]
    )
    vectorSource.addFeature(feature)
  })
}

//动画
function animation() {
  if (radius >= 40) {
    radius = 0
  }
  var opacity = (40 - radius) / 40 //不透明度
  var pointStyle = new Style({
    image: new CircleStyle({
      fill: new Fill({
        color: 'rgba(54,110,255,' + opacity + ')',
      }),
      radius: radius,
      // stroke: new Stroke({
      //   color: '#00ff5a',
      //   width: 4 - radius / 10,
      // }),
    }),
  })
  let features = vectorSource.getFeatures()
  features.forEach((element) => {
    if (element.get('grade') == 1) {
      element.setStyle([
        pointStyle,
        new Style({
          image: new CircleStyle({
            fill: new Fill({
              color: 'rgba(54,110,255,0.5)',
            }),
            radius: 20,
          }),
        }),
        new Style({
          image: new CircleStyle({
            fill: new Fill({
              color: '#366EFF',
            }),
            stroke: new Stroke({
              color: '#FFF',
              width: 2,
            }),
            radius: 10,
          }),
        }),
      ])
    }
  })

  radius = radius + 0.3
  iMap.render()
}
//鼠标悬停事件
function MapPointerMove(evt) {
  var pixel = iMap.getEventPixel(evt.originalEvent)
  var hit = iMap.hasFeatureAtPixel(pixel)
  if (hit) {
    var feature = iMap.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      return feature
    })
    if (feature) {
      if (feature.get('_type') == 'vector') {
        element.innerHTML = feature.get('name') + '\n' + feature.get('value') + '条'
        iMap.getTargetElement().style.cursor = 'pointer'
        popup.setPosition(feature.getGeometry().getCoordinates())
      } else {
        iMap.getTargetElement().style.cursor = ''
        popup.setPosition(undefined)
      }
    } else {
      iMap.getTargetElement().style.cursor = ''
    }
  } else {
    iMap.getTargetElement().style.cursor = ''
    popup.setPosition(undefined)
  }
}

//地图放大缩小
function mapMoved(e) {
  var zoom = iMap.getView().getZoom();
  let features = vectorSource.getFeatures()
  if (zoom > 11) {
    if (scale != 11) {
      features.forEach((element) => {
        var custom;
        if(element.get('grade')==1){
          custom='../../../../static/img/customer1.svg'
        }else if(element.get('grade')==5){
          custom='../../../../static/img/customer3.svg'
        }else{
          custom='../../../../static/img/customer2.svg'
        }
        element.setStyle(new Style({
          image: new Icon({
            scale: 1,
            src: custom
          }),
          text: new Text({
            font: 'bold 12px sans-serif',
            text: element.get('name'),
            textAlign: 'center',
            offsetY: 25,
            stroke: new Stroke({
              color: 'white'
            }),
            fill: new Fill({
              color: '#0079e9'
            }),
          })
        }))
      })
      scale = 11
    }
  } else if (zoom < 4) {
    if (scale != 4) {
      features.forEach((element) => {
        var custom;
        if(element.get('grade')==1){
          custom='../../../../static/img/customer1.svg'
        }else if(element.get('grade')==5){
          custom='../../../../static/img/customer3.svg'
        }else{
          custom='../../../../static/img/customer2.svg'
        }
        element.setStyle(new Style({
          image: new Icon({
            scale: 0.2,
            src: custom
          }),
        }))
      })
      scale = 4
    }
  } else {
    if (scale != 7) {
      features.forEach((element) => {
        var custom;
        if(element.get('grade')==1){
          custom='../../../../static/img/customer1.svg'
        }else if(element.get('grade')==5){
          custom='../../../../static/img/customer3.svg'
        }else{
          custom='../../../../static/img/customer2.svg'
        }
        element.setStyle(new Style({
          image: new Icon({
            scale: 0.5,
            src: custom
          }),
        }))
      })
      scale = 7
    }
  }
}

//地图点击事件
function MapPointerClickOpen(evt) {
  var pixel = iMap.getEventPixel(evt.originalEvent)
  var hit = iMap.hasFeatureAtPixel(pixel)
  if (hit) {
    var feature = iMap.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
      return feature
    })
    if (feature) {
      _this.dataList = true;
      _this.queryList(feature.get('compayId'))
    }
  } else {
    _this.pageNumber = 1;
    _this.getTubiao(_this.param)
  }
}

//增加省区域层
function addProvinceVector() {
  let data = _this.provinceData.features
  for (let i = 0; i < data.length; i++) {
    for (let j = 0; j < data[i]["geometry"]["coordinates"].length; j++) {
      let datajson = []
      data[i]["geometry"]["coordinates"][j][0].forEach((item) => {
        datajson.push(fromLonLat(item))
      })
      var feature = new Feature({
        geometry: new Polygon([datajson]),

      })
      feature.setStyle(new Style({
        stroke: new Stroke({
          color: '#0066FF',
          width: 1,
        }),
        fill: new Fill({
          color: 'rgba(87, 124, 204, 0.2)',
        }),
        text: new Text({
          font: '14px bold sans-serif',
          text: data[i]["properties"]["name"],
          fill: new Fill({
            color: 'rgba(255,255,255,0.8)',
          }),
          stroke: new Stroke({
            color: '#06798a',
            width: 0.5,
          }),
          overflow: false
        }),

      }))
      feature.set('_type', 'province')
      provinceSorce.addFeature(feature)
    }
  }
}

//增加绘制点事件
function addDrawPoint() {
  var _Draw = new Draw({
    source: vectorSource,
    stopClick: true,
    type: 'Point'
  });
  iMap.addInteraction(_Draw);
  _Draw.on('drawend', function (evt) {
    var coordinate = evt.feature.getGeometry().getCoordinates();
    // _this.positions(coordinate)
    vectorSource.clear()
    let rome = new Feature({
      geometry: new Point(coordinate)
    });
    rome.setStyle(
      new Style({
        image: new CircleStyle({
          fill: new Fill({
            color: 'rgba(0,255,216,1)',
          }),
          radius: 10,
        }),
      })
    )
    vectorSource.addFeature(rome)
  })
}

//增加点
function addPoint() {
  vectorSource.clear()
  if (_this.position != '') {
    if (_this.position[0] < 200) {
      _this.position = fromLonLat(_this.position)
    }
    let rome = new Feature({
      geometry: new Point(_this.position)
    });

    rome.setStyle(
      new Style({
        image: new CircleStyle({
          fill: new Fill({
            color: 'rgba(0,255,216,1)',
          }),
          radius: 10,
        }),
      })
    )
    vectorSource.addFeature(rome)
  }
}

//地图位置重定位
function rewritePos(position) {
  _this.position = [fromLonLat(position)[0] - 724, fromLonLat(position)[1] - 724]
  // _this.positions(_this.position)
  iMap.getView().animate({
    center: _this.position,
    duration: 500
  })
  addPoint()
}

function lonLat2Mercator(lonlat) {
  var mercator = []
  var earthRad = 6378137.0;
  mercator[0] = lonlat[0] * Math.PI / 180 * earthRad;
  var a = lonlat[1] * Math.PI / 180;
  mercator[1] = earthRad / 2 * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
  return mercator;
}

function toLonLat_(coordinate) {
  return toLonLat(coordinate)
}

//修改地图自适应
function changeMapSize() {
  iMap.updateSize()
}
// normal 12px 黑体
/**
 * coordinate:传入标记点左边
 * 
 * imageSrc:传入标记点图片，正确的图片链接
 * 
 * text:标记点显示的名称
 * 
 * textStyle:名称文字显示样式
 * 
 * offsetY:名称位置坐标便宜   屏幕坐标系  数值越大越向下
 * 
 * fillColor:名称文字颜色
 */
function drawIcon(coordinate, imageSrc, text, textStyle, offsetY, fillColor) {
  var pos
  if (coordinate[0] < 200) {
    pos = fromLonLat(coordinate)
  } else {
    pos = coordinate
  }
  var feature = new Feature({
    geometry: new Point(pos)
  })
  feature.setStyle(new Style({
    image: new Icon({
      color: '#BADA55',
      scale: 1,
      src: imageSrc
    }),
    text: new Text({
      text: text,
      font: textStyle,
      textAlign: 'center',
      offsetY: offsetY,
      fill: new Fill({
        color: fillColor
      }),
    })
  }))
  provinceSorce.addFeature(feature)

  //增加底部样式
  var room = new Feature({
    geometry: new Point(pos)
  })
  vectorSource.addFeature(room)

}

export {
  sendThis,
  Load_Map,
  addCricle,
  addProvinceVector,
  addDrawPoint,
  addPoint,
  rewritePos,
  toLonLat_,
  changeMapSize,
  drawIcon
}


// WEBPACK FOOTER //
// ./src/views/administrator/console/assembly/openlayers/iMap.js